import { Base } from '@codesuma/baseline'

export const Bar = (height = 4, options: any = {}) => {

    const base = Base('div')

    base.style({
        height: height + 'px',
        backgroundColor: options.bg || '#ffffff',
        borderRadius: '2px',
        width: '100%',
    })

    return base
}